/**
 * Generated runtime TestId mirror for frontend/src/components/account/AccountStatusEventsTimeline.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccountStatusEventsTimelineTestIds = {
  accountStatusEventTriggerRefLink: "account-status-event-trigger-ref-link",
  accountStatusEventsTimeline: "account-status-events-timeline",
  accountStatusFiltersPanel: "account-status-filters-panel",
  accountStatusTimelineEmpty: "account-status-timeline-empty",
  accountStatusTimelineError: "account-status-timeline-error",
  accountStatusTimelineLoading: "account-status-timeline-loading",
  accountStatusTimelineRows: "account-status-timeline-rows",
  btnClearAccountStatusFilters: "btn-clear-account-status-filters",
  btnToggleAccountStatusFilters: "btn-toggle-account-status-filters",
  inputAccountStatusFilterFrom: "input-account-status-filter-from",
  inputAccountStatusFilterTo: "input-account-status-filter-to",
  accountStatusEvent: (event_id: string) => `account-status-event-${event_id}`,
  accountStatusEventPrefix: () => "account-status-event-" as TestIdPrefix,
  accountStatusEventTrigger: (event_id: string) => `account-status-event-${event_id}-trigger`,
  accountStatusEventActor: (event_id: string) => `account-status-event-${event_id}-actor`,
  accountStatusEventReason: (event_id: string) => `account-status-event-${event_id}-reason`,
  accountStatusEventCascadedLink: (event_id: string) => `account-status-event-${event_id}-cascaded-link`
} as const;
